<template>
  <div class="my-schedule-calendar-div">
    <div class="my-schedule-calendar-exchangediv">
      <div class="front" @click="goFront">
        <span class="iconfont icon-zuo"></span>
      </div>
      <div class="time">{{currentYear}}年{{currentMonth}}月</div>
      <div class="next" @click="goNext">
        <span class="iconfont icon-weibiaoti34"></span>
      </div>
    </div>
    <div class="my-schedule-calendar-header">
      <van-grid :border="false" :column-num="7">
        <van-grid-item v-for="(item , index) in titleArray" :key="'titleitem' + index">
          <div class="header-text">{{item}}</div>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="my-schedule-calendar-main">
      <div v-for="(weekItem , weekIndex) in dataObject.data" :key="'dayItem' + weekIndex" class="my-schedule-calendar-week">
        <van-grid :border="false" :column-num="7">
          <van-grid-item v-for="(dayItem , tempIndex) in weekItem" :key="'dayItem' + tempIndex" class="my-schedule-calendar-monthcontent-day" @click="jumpDate(dataObject.year,dataObject.month,dayItem.gregorian,dayItem.hasCourse)">
            <div v-if="selectDate == dayItem.gregorian" id="monthcontent-todaybackground-div" class="monthcontent-todaybackground-div"></div>
            <div v-if="selectDate == dayItem.gregorian" class="todaynumber-text">{{dayItem.gregorian}}</div>
            <div v-else class="daynumber-text" :class="tempIndex == 0 || tempIndex == weekItem.length - 1 ? 'holiday-text' : 'normal-text'">{{dayItem.gregorian}}</div>
            <!-- <div v-if="dayItem.isToday" class="todayoldday-text">{{dayItem.lunar}}</div>
            <div v-else class="oldday-text" :class="tempIndex == 0 || tempIndex == weekItem.length - 1 ? 'holiday-text' : 'normal-text'">{{dayItem.lunar}}</div> -->
            <div v-if="dayItem.hasCourse" class="hascourse-point-div">
              <div :class="selectDate == dayItem.gregorian ? 'select-hascourse-point' : 'normal-hascourse-point'"></div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileMyScheduleCalendar",
  ctrlCaption: "我的课表日历组件",
  mixins: [$mixins.control],
  components: {},
  design: {
    isMask: false,
  },
  data() {
    return {
      titleArray: ["日", "一", "二", "三", "四", "五", "六"],
      dataObject:{},
      currentYear:0,
      currentMonth:0,
      currentDate:0,
      selectYear:0,
      selectMonth:0,
      selectDate:0,
      startDate:"",
      endDate:"",
      hasToday: false,
      hasCourseDataArray:[],
      classId: "",
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
  },
  created() {
    if(this.isDesign){
      let currentDate = new Date();
      this.currentYear = currentDate.getFullYear();
      this.currentMonth = currentDate.getMonth() + 1;
      this.currentDate = currentDate.getDate();
      this.$dispatch("design-width-change", "100%");
      // this.dataObject = this.getDays(this.currentYear, this.currentMonth);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    firstLoadData(){
      let currentDate = new Date();
      this.currentYear = currentDate.getFullYear();
      this.currentMonth = currentDate.getMonth() + 1;
      this.currentDate = currentDate.getDate();
      this.loadMonthData();
    },
    // 获取当前月份所有公历日期及其农历日期
    getDays(year, month) {
      this.hasToday = false;
      let days = [];
      const time = new Date();
      time.setFullYear(year, month, 0);

      let totalDay = time.getDate();
      const firstDay = new Date(year, month - 1, 1); // 当月第一天
      const lastDay = new Date(year, month - 1, totalDay); // 当月最后

      // 获取星期中的第几天（0-6）(星期日-星期六)
      let weekIndex = firstDay.getDay();

      let currentIndex = -1;
      let tempDate = new Date();
      let tempYear = tempDate.getFullYear();
      let tempMonth = tempDate.getMonth() + 1;
      let tempDayNumber = tempDate.getDate();
      if(tempYear == year && tempMonth == month){
        currentIndex = tempDayNumber;
      }

      let _time = year + "-" + (month < 10 ? "0" + month : month);

      const lastWeekIndex = lastDay.getDay();
      let tempArr = [];
      for (let i = 1; i <= totalDay; i++) {
        if (i == 1 && weekIndex != 0) {
          for (let temp = 0; temp < weekIndex; temp++) {
            tempArr.push({ gregorian: "", lunar: "", hasCourse: false, isToday: false });
          }
        }
        let arrangeTime = _time + "-" + (i < 10 ? "0" + i : i);
        if(this.hasCourseDataArray.indexOf(arrangeTime) > - 1){
          if(currentIndex > 0 && currentIndex == i){
            this.hasToday = true;
            tempArr.push({
              gregorian: i,
              lunar: "",//getYearMonthDay(year, month, i)
              hasCourse: true,
              isToday: true,
            });
          }else{
            tempArr.push({
              gregorian: i,
              lunar: "",//getYearMonthDay(year, month, i)
              hasCourse: true,
              isToday: false,
            });
          }
        }else{
          if(currentIndex > 0 && currentIndex == i){
            this.hasToday = true;
            tempArr.push({
              gregorian: i,
              lunar: "",//getYearMonthDay(year, month, i)
              hasCourse: false,
              isToday: true,
            });
          }else{
            tempArr.push({
              gregorian: i,
              lunar: "",//getYearMonthDay(year, month, i)
              hasCourse: false,
              isToday: false,
            });
          }
        }
        if (i == totalDay && lastWeekIndex != 6) {
          for (let temp = 0; temp < 6 - lastWeekIndex; temp++) {
            tempArr.push({ gregorian: "", lunar: "", hasCourse: false, isToday: false });
          }
        }
        if (tempArr.length == 7) {
          let weekArray = tempArr;
          days.push(weekArray);
          tempArr = [];
        }
      }
      return {
          year : year,
          month : month,
          data : days,
      };
    },
    loadCurrentData() {
      if(this.isDesign){
        return;
      }
      const loading = dsf.layer.loading();
      let urlString = "";
      let params = {};
      urlString = this.url || "";
      console.log(urlString);
        params = {
          stime: this.startDate,
          etime: this.endDate,
          isnum: true,
        };
      let _this = this;
      this.$http
        .get(urlString, params)
        .done((res) => {
          dsf.layer.closeLoading(loading);
          if (res.success) {
            let tempDataObject = res.data || {};
            _this.hasCourseDataArray = Object.keys(tempDataObject) || [];
            _this.getDayData();
          } else {
            dsf.layer.message(res.message || "请求失败", false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "出错了，请重试", false);
        });
    },
    getDayData(){
      this.dataObject = this.getDays(this.currentYear, this.currentMonth);
      this.selectYear = this.currentYear;
      this.selectMonth = this.currentMonth;
      if(this.hasToday){
        this.selectDate = this.currentDate;
      }else{
        this.selectDate = 1;
      }
      let tempDayString = this.selectYear + "-" + (parseInt(this.selectMonth) < 10 ? "0" + this.selectMonth : this.selectMonth) + "-" + (parseInt(this.selectDate) < 10 ? "0" + this.selectDate : this.selectDate);
      this.$emit("loadDayDataArray", tempDayString);
    },
    goFront(){
        this.currentMonth --;
        if(this.currentMonth == 0){
          this.currentYear --;
          this.currentMonth = 12;
        }
        this.loadMonthData();
    },
    goNext(){
        this.currentMonth ++;
        if(this.currentMonth > 12){
          this.currentYear ++;
          this.currentMonth = 1;
        }
        this.loadMonthData();
    },
    loadMonthData(){
      let timeString = this.currentYear + "-" + (parseInt(this.currentMonth) < 10 ? "0" + this.currentMonth : this.currentMonth) + "-";
      let tempEndMonth = new Date(this.currentYear , this.currentMonth , 0);
      let dayCount = tempEndMonth.getDate();
      this.startDate = timeString + "01" + " " + "00:00:00";
      this.endDate = timeString + dayCount + " " + "23:59:59";
      this.loadCurrentData();
    },
    jumpDate(year,month,day,hasCourse){
      if(parseInt(day) > 0){
        let timeString = year + "-" + (parseInt(month) < 10 ? "0" + month : month) + "-" + (parseInt(day) < 10 ? "0" + day : day);
        this.selectDate = day;
        this.$emit("loadDayDataArray", timeString);
      }
    }
  },
});
</script>
<style lang="scss">
</style>
